var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artists"},[_c('h4',{staticClass:"title"},[_vm._v("Artists")]),_c('Category',{attrs:{"title":"Trending Now","artists":_vm.trending}}),_c('Category',{attrs:{"title":"Popular","artists":_vm.popular}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }